<template>
  <footer class="footer">
    <p>赣州市农技学堂公共服务平台 版权所有 联系我们</p>
    <p>网站标识码：4100000042 赣公网安备：41010502003827 赣ICP备12010840号-1</p>
    <p>建议使用：1920*1080分辨率，IE10以上版本浏览器  技术支持：赣州通信服务公司</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
.footer {
  background-color: #333;
  color: white;
  padding: 10px;
  text-align: center;
}
</style>